import { render, staticRenderFns } from "./RowActionsPopover.vue?vue&type=template&id=23d457db&"
import script from "./RowActionsPopover.vue?vue&type=script&lang=js&"
export * from "./RowActionsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports